module Meevo.Plugins.ReportingHierarchy {
    "use strict";

    /**
     * Main Section of Client
     */
    import IReportingHierarchyBranch = Meevo.Model.IReportingHierarchyBranch;

    export class SetLocationsSection extends BaseSection {
        
        hasChanges: boolean = false;

        fromShortcut: boolean = false;
        hideInactive: boolean = false;
        allLocationsSelected: boolean = false;

        nodes: IReportingHierarchyBranch[] = [];
        tree: IReportingHierarchyBranch[] = [];
        nodesById: {
            [key: string]: IReportingHierarchyBranch
        };

        locationsInitialized: boolean = false;

        locationsByNode: {
            [key: string]: number[]
        }

        locationsBackup: {
            [key: string]: number[]
        }

        locationsById: any;
        locations: Meevo.Model.Location[] = [];
        locationsForMover: Meevo.Model.Location[] = [];
        
        allLocationSelection: number[] = [];
        nodeLocationSelection: number[] = [];

        searchInProgress: boolean = false;
        searchCriteria: {
            city?: {
                id: number,
                city: string
            },
            state?: {
                id: number,
                state: string
            },
            storeNumber? : string,
            zipCode?: number,
            filter?: string,
            retrieveIdOnly: boolean
        } = {
            retrieveIdOnly: true
        };

        cityCriteria: {
            state?: string
        } = {};
                
        selectedNode: string;

        protected appSettings;

        constructor(params: Meevo.Model.ISectionParamsBaseDataService) {
            super(params);

            this.appSettings = params.appSettings;
        }
        
        activate() {
           
            super.activate();

            this.fetchBranches();

            this.fetchLocations();
        }

        fetchBranches() {
            this.loadingInProgress = true;
            return this.dataService.getItem(`${this.baseEndpoint}Tree/${this.model.id}`)
                .then((res: any) => {
                    const self = this;

                    this.nodes = res.branches.map((node: IReportingHierarchyBranch) => {
                        if (!angular.isDefined(node.parentBranch_TId)) {
                            node.parentBranch_TId = null;
                        }

                        return node;
                    });

                    this.tree = this.nodes.map((node): IReportingHierarchyBranch => {
                        node.nodes = this.nodes.filter(n => n.parentBranch_TId === node.branch_TId);
                        return node;
                    }).filter(node => {
                        return node.parentBranch_TId === null;
                    });

                    this.nodesById = this.nodes.reduce((lookup, node) => (lookup[node.branch_TId] = node, lookup), {}) as any;

                    if (this.locationsInitialized) {
                        this.loadingInProgress = false;
                    }
                });
        }

        fetchLocations() {
           
            this.loadingInProgress = true;
            return this.dataService.getItem(`${this.baseEndpoint}LocationTree/${this.model.id}`)
                .then((res: any) => {

                    this.locationsByNode = res.reduce((lookup, node) => (lookup[node.branch_TId === emptyGuid() ? 'null' : node.branch_TId] = node.locationIds, lookup), {});
                    this.takeLocationsBackup();

                    let locationIds = [];
                    res.forEach(function collectIds(node) {
                        locationIds = locationIds.concat(node.locationIds);
                    })

                    return this.dataService.customMethodData(`/${this.appSettings.API_ROOT}/${this.baseEndpoint}/Location/list`, 'POST', { locationIds })
                        .then((res) => {
                            const locations = res.data;

                            this.locationsById = locations.reduce((acc, loc) => (acc[loc.id] = loc.name, acc), {});
                            this.locations = locations.map(x => ({ locationId: x.id, storeName: x.name, subscriptionStatus: x.subscriptionStatus}));
                            this.setLocationsForMover();
                        })
                })
                .finally(() => {
                    this.loadingInProgress = false;
                    this.locationsInitialized = true;
                })
        }

        rollbackChanges() {            
            this.locationsByNode = angular.copy(this.locationsBackup);
            this.hasChanges = false;
            
            this.resetSearch();

            super.rollbackChanges();
        }

        takeLocationsBackup() {
            this.locationsBackup = angular.copy(this.locationsByNode);
        }

        searchLocations() {
            const criteria = angular.merge({}, this.searchCriteria, {
                ExcludeRptHierarchy: this.model.id
            });

            if (criteria.city) criteria.city = criteria.city.city;
            if (criteria.state) criteria.state = criteria.state.state;
            
            const request = {
                criteria,
                pageNumber: 0,
                itemsPerPage: 100000,
                includeActive: true,
                includeDeleted: false,
                includeInactive: false
            }

            this.searchInProgress = true;
            this.dataService.getListPaged('location', request)
                .then((resLocations: number[]) => {
                    if (!angular.isDefined(this.locationsByNode['all'])) {
                        this.locationsByNode['all'] = this.locationsByNode['null']
                    }
                    this.locationsByNode['null'] = resLocations;
                    var availableLocations = this.locations.filter(l => resLocations.indexOf(l.locationId) > -1 && (this.hideInactive ? l.subscriptionStatus == Meevo.Model.SubscriptionStatusEnum.Active : true));
                    var currLocations = this.locations.filter(l => this.locationsBackup[this.selectedNode].indexOf(l.locationId) > -1 && (this.hideInactive ? l.subscriptionStatus == Meevo.Model.SubscriptionStatusEnum.Active : true));;

                    if (currLocations) {
                        this.locationsForMover = availableLocations.concat(currLocations);
                    }
                    else {
                        this.locationsForMover = angular.copy(availableLocations);
                    }

                })
                .finally(() => {
                    this.searchInProgress = false;
                })
        }

        resetSearch() {
           
            this.searchCriteria = {
                retrieveIdOnly: true
            }

            if (angular.isDefined(this.locationsByNode['all'])) {
                this.locationsByNode['null'] = this.locationsByNode['all'];
            }            
            delete this.locationsByNode['all'];

            this.locationsByNode = angular.copy(this.locationsBackup);

            this.setLocationsForMover();
            
            this.hideInactive = false;
            this.allLocationsSelected = false;
        }
        moveLocations() {
            this.hasChanges = true;

            if (!angular.isDefined(this.locationsByNode[this.selectedNode])) {
                this.locationsByNode[this.selectedNode] = []
            }

            this.locationsByNode['null'] = this.locationsByNode['null'].filter(l => this.allLocationSelection.indexOf(l) === -1);
            if (angular.isDefined(this.locationsByNode['all'])) {
                this.locationsByNode['all'] = this.locationsByNode['all'].filter(l => this.allLocationSelection.indexOf(l) === -1);
            }
            this.locationsByNode[this.selectedNode] = this.locationsByNode[this.selectedNode].concat(this.allLocationSelection);
        }

        moveAllLocations() {
            this.hasChanges = true;

            if (!angular.isDefined(this.locationsByNode[this.selectedNode])) {
                this.locationsByNode[this.selectedNode] = []
            }

            this.locationsByNode[this.selectedNode] = this.locationsByNode[this.selectedNode].concat(this.locationsByNode['null']);
            if (angular.isDefined(this.locationsByNode['all'])) {
                this.locationsByNode['all'] = this.locationsByNode['all'].filter(l => this.locationsByNode['null'].indexOf(l) === -1);
            }
            this.locationsByNode['null'] = [];
        }

        removeLocations() {
            this.hasChanges = true;

            this.locationsByNode[this.selectedNode] = this.locationsByNode[this.selectedNode].filter((x: number) => this.nodeLocationSelection.indexOf(x) === -1);
            if (angular.isDefined(this.locationsByNode['all'])) {
                this.locationsByNode['all'] = this.locationsByNode['all'].concat(this.nodeLocationSelection);
            }
            this.locationsByNode['null'] = this.locationsByNode['null'].concat(this.nodeLocationSelection);
        }

        removeAllLocations() {
            this.hasChanges = true;

            this.locationsByNode['null'] = this.locationsByNode['null'].concat(this.locationsByNode[this.selectedNode]);
            if (angular.isDefined(this.locationsByNode['all'])) {
                this.locationsByNode['all'] = this.locationsByNode['all'].concat(this.locationsByNode[this.selectedNode]);
            }
            this.locationsByNode[this.selectedNode] = [];
        }
        
        onChangeConfirm() {
            this.rollbackChanges();
        }

        onStateChange() {
            if (this.searchCriteria.state) {
                delete this.searchCriteria.city;
                this.cityCriteria.state = this.searchCriteria.state.state;
            } else {
                delete this.cityCriteria.state;
            }
        }

        setLocationsForMover() {
            this.locationsForMover = this.hideInactive
                ? this.locations.filter(l => l.subscriptionStatus == Meevo.Model.SubscriptionStatusEnum.Active)
                : this.locations;
        }

        public serialize() {
            
            return {
                id: this.model.id,
                entityVersion: this.model.entityVersion,
                bottomBranchId: this.selectedNode,
                locationIds: this.locationsByNode[this.selectedNode]
            };
        }
        
    }
}